import { client } from "@/queries/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

interface AirportUpdatePayload {
  connecting_factor?: number | null;
}

const airportQueryKeys = {
  detail: ["airport", "details"] as const,
};

export function useAirportDetails() {
  return useQuery({
    queryKey: airportQueryKeys.detail,
    queryFn: async ({ signal }) => {
      const { data, error } = await client.get().GET("/api/airport/", {
        signal,
      });

      if (data) return data;

      console.error("Failed to fetch airport details:", error);
      const detail = (error as any)?.detail;
      throw new Error(
        detail || "An unknown error occurred while fetching airport details."
      );
    },
  });
}

export function useUpdateAirportDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AirportUpdatePayload) => {
      const { data, error } = await client.get().PATCH("/api/airport/", {
        body: payload,
      });

      if (data) return data;

      console.error("Failed to update airport details:", error);
      const detail = (error as any)?.detail;
      throw new Error(
        detail || "An unknown error occurred while updating airport details."
      );
    },
    onSuccess: (updatedAirportData) => {
      queryClient.setQueryData(airportQueryKeys.detail, updatedAirportData);
    },
    onError: (error) => {
      console.error("Mutation error:", error.message);
    },
  });
}
